export const getGlobalTransactions = {
    GET_GLOBAL_TRANSACTIONS_REQUEST: "GET_GLOBAL_TRANSACTIONS_REQUEST",
    GET_GLOBAL_TRANSACTIONS_SUCCESS: "GET_GLOBAL_TRANSACTIONS_SUCCESS",
    GET_GLOBAL_TRANSACTIONS_ERROR: "GET_GLOBAL_TRANSACTIONS_ERROR",
}

export const getGlobalImpTransactions = {
    GET_GLOBAL_IMP_TRANSACTIONS_REQUEST: "GET_GLOBAL_IMP_TRANSACTIONS_REQUEST",
    GET_GLOBAL_IMP_TRANSACTIONS_SUCCESS: "GET_GLOBAL_IMP_TRANSACTIONS_SUCCESS",
    GET_GLOBAL_IMP_TRANSACTIONS_ERROR: "GET_GLOBAL_IMP_TRANSACTIONS_ERROR",
}

export const getGlobalTransactionSummary = {
    GET_GLOBAL_TRANSACTIONS_SUMMARY_REQUEST: "GET_GLOBAL_TRANSACTIONS_SUMMARY_REQUEST",
    GET_GLOBAL_TRANSACTIONS_SUMMARY_SUCCESS: "GET_GLOBAL_TRANSACTIONS_SUMMARY_SUCCESS",
    GET_GLOBAL_TRANSACTIONS_SUMMARY_ERROR: "GET_GLOBAL_TRANSACTIONS_SUMMARY_ERROR",
}